/* eslint-disable */
export default {
  loading: 'Loading...',
} as const;

// @key: @#@"loading"@#@ @source: @#@"Loading ..."@#@
